{
  "version": 1,
  "asset_id": "e4be709b-4a75-4a65-acaf-d8421efcf313",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e4be709b-4a75-4a65-acaf-d8421efcf313/hero-new-800.jpg",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e4be709b-4a75-4a65-acaf-d8421efcf313/hero-new-800.jpg",
  "original_filename": "hero-new-800.jpg",
  "size": 43290,
  "content_type": "image/jpeg",
  "created_at": "2026-07-24T08:10:42Z"
}
